import qs from 'querystring';
import ReactDOM from 'react-dom';
import Cookies from 'js-cookie';
import {
  isNative,
  SDK_VERSION,
  USE_TYPE_ENV,
  searchObj,
  WEBID_KEY,
  isMobile,
} from '../utils/constants';

export function sortMapByTime(map: Obj[], key: string) {
  map.sort((a, b) => {
    return a[key] - b[key];
  });
}
export function standardNativeParams(search: string) {
  const searchObj = getQuery(search);
  // 因为native sdk传过来的ch vc跟埋点字段不一致，这里做个适配(安卓端和ios端不一致)
  searchObj.channel = searchObj.ch || searchObj.channel; // app渠道
  searchObj.app_version = searchObj.vc || searchObj.app_version; // app版本
  searchObj.region = searchObj.region || searchObj.tea_channel;
  // 去掉verify_data和theme不需要传给后端的query参数
  if (searchObj.verify_data) {
    delete searchObj.verify_data;
  }
  if (searchObj.theme) {
    delete searchObj.theme;
  }
  return searchObj;
}

export function detectCaptchaOptions(options: any = {}) {
  if (Object.prototype.toString.call(options) !== '[object Object]') {
    // throw 出来的错误可能在业务方的浏览器调试器中无法探测到
    console.error('Options must be an object'); // eslint-disable-line
    throw new Error('Options must be an object');
  }
  const { aid, iid, did } = options;
  const initErrorCb =
    typeof options.initErrorCb === 'function'
      ? options.initErrorCb
      : function (msg: string) {
          console.error(msg); // eslint-disable-line
        };
  if (typeof aid !== 'number') {
    initErrorCb('The parameter aid is required and of type int');
    throw new Error('The parameter aid is required and of type int');
  }

  if (typeof iid !== 'string') {
    initErrorCb('The parameter iid is required and of type string');
    throw new Error('The parameter iid is required and of type string');
  }

  if (typeof did !== 'string') {
    initErrorCb('The parameter did is required and of type string');
    throw new Error('The parameter did is required and of type string');
  }
}
export function detectSecondVerifyWebOptions(options: any = {}) {
  if (Object.prototype.toString.call(options) !== '[object Object]') {
    // throw 出来的错误可能在业务方的浏览器调试器中无法探测到
    console.error('Options must be an object'); // eslint-disable-line
    throw new Error('Options must be an object');
  }
  const { aid, account } = options;
  const initErrorCb =
    typeof options.initErrorCb === 'function'
      ? options.initErrorCb
      : function (msg: string) {
          console.error(msg); // eslint-disable-line
        };
  if (typeof aid !== 'number') {
    initErrorCb('The parameter aid is required and of type int');
    throw new Error('The parameter aid is required and of type int');
  }
}

// 获取验证码挂载元素
export function getRootElem(qs_total: any) {
  // ele
  let rootElem = document.getElementById(qs_total.ele);
  if (!rootElem) {
    rootElem = document.createElement('div');
    rootElem.id = qs_total.ele;
    document.body.appendChild(rootElem);
  } else {
    ReactDOM.unmountComponentAtNode(rootElem);
  }
  if (
    !qs_total.disableSetBodyHidden &&
    document.body.classList &&
    document.body.classList.add
  ) {
    document.body.classList.add('captcha-disable-scroll');
  }
  rootElem.style.display = 'block';
  if (qs_total.showMode === 'mask') {
    rootElem.style.zIndex = '111111';
    rootElem.style.position = 'fixed';
    rootElem.style.width = '100%';
    rootElem.style.height = '100%';
    rootElem.style.backgroundColor = 'rgba(0, 0, 0, 0.512)';
    rootElem.style.margin = 'auto';
    rootElem.style.top = '0px';
    rootElem.style.bottom = '0px';
    rootElem.style.left = '0px';
    rootElem.style.right = '0px';
  }
  return rootElem;
}

export const setAppFontMotion = () => {
  const rootElem = document.getElementById(window.captchaOptions.ele);
  if (rootElem) {
    rootElem.style.transition = 'font-size 0.3s cubic-bezier(0.42, 0, 0.58, 1)';
  }
};

export const removeAppFontMotion = () => {
  const rootElem = document.getElementById(window.captchaOptions.ele);
  if (rootElem) {
    rootElem.style.transition = 'none';
  }
};

export function getQuery(search: string) {
  const search_index = search.indexOf('?');
  const search_str =
    search_index > -1 ? search.substring(search_index + 1) : '';
  try {
    // 默认解析utf-8编码查询字符串，gbk2312编码解析不了，需要catch
    return qs.parse(search_str);
  } catch (err) {
    return {};
  }
}

function getWebRegion(options: any) {
  let env_region = 'va';
  switch (process.env.REGION_ENV) {
    case 'boe':
    case 'cn':
      env_region = 'cn';
      break;
    case 'sg':
      env_region = 'sg';
      break;
    case 'va':
      env_region = 'va';
      break;
    case 'in':
      env_region = 'in';
      break;
  }
  return options.region || options.tea_channel || env_region;
}

export function getOs() {
  const userAgent = window.navigator.userAgent;
  /** * 是否为windows系统 * */
  if (/windows|win32/i.test(userAgent)) {
    return 'windows';
  }
  /** * 是否为安卓 * */
  if (userAgent.indexOf('Android') > -1 || userAgent.indexOf('Adr') > -1) {
    return 'Android';
  }
  /** * 是否为ios * */
  if (/\(i[^;]+;( U;)? CPU.+Mac OS X/.test(userAgent)) {
    return 'iOS';
  }
  /* 是否为MAC*/
  if (/macintosh|mac os x/i.test(userAgent)) {
    return 'mac';
  }

  return 'other';
}

// 预处理options
export function setOptions(options: any) {
  options.ele = options.ele || 'captcha_container';
  options.zIndex = options.zIndex || '111111';
  options.h5_sdk_version = SDK_VERSION;
  options.h5_sdk_use_type = USE_TYPE_ENV;
  options.webdriver = String(window.navigator.webdriver);
  if (isNative) {
    // 只有native端需要从query上取数据,region是必传
    options = Object.assign(options, searchObj);
    // app端透传os_name
    options.os_name = options.os_name || '';
    options.platform = 'app';
  } else {
    // 非APP端自行判断os_name和platform
    // 为了做版本兼容，region从region或tea_channel取，region不存在取tea_channel
    options.region = getWebRegion(options);
    options.os_name = getOs();
    options.platform = isMobile ? 'h5' : 'pc';
  }
  return options;
}

// 整理tea的通用参数
export function getTeaCommonParams(options: Record<string, any>) {
  let qs_total = {
    aid: options.aid || 0,
    did: options.did || '0',
    iid: options.iid || '0',
    type: 2, // 短信和图片验证码，1 表示短信 2 表示图片验证
    h5_sdk_version: SDK_VERSION,
    h5_sdk_use_type: USE_TYPE_ENV,
    platform: options.platform,
    os_name: options.os_name,
    once: Date.now(), // 用时间戳来表示当次前端的出码记录，用于串连一次前端出码记录的所有点
  } as any;
  if (isNative) {
    qs_total = Object.assign(qs_total, searchObj);
    // 去除qs_total一些无关数据
    if (qs_total.verify_data) delete qs_total.verify_data;
    if (qs_total.theme) delete qs_total.theme;
  } else {
    qs_total.region = options.region;
  }
  return qs_total;
}

// 用来captcha/verify和captcha/get接口的query参数整理
export function getQueryParams(props: Record<string, any>) {
  const {
    aid,
    lang,
    app_name,
    ch,
    iid,
    did,
    os_type,
    h5_sdk_version,
    h5_sdk_use_type,
    sdk_version,
    verify_data,
    type,
    mode,
    challenge_code,
    platform,
    os_name,
    webdriver,
  } = props;
  const qs_total = Object.assign(
    {
      lang,
      app_name,
      h5_sdk_version,
      h5_sdk_use_type,
      sdk_version,
      iid,
      did,
      device_id: did,
      ch,
      aid,
      os_type,
      mode,
      tmp: Date.now(),
      platform,
      webdriver,
    },
    // 移动端透传query参数给后端
    isNative ? searchObj : {}
  );
  // 不能使用isNative判断，因为web端也支持业务方透传os_type, 模拟app传参
  //  当os_type为0或1时，组合did + iid为唯一身份标识
  // os_type为web端时，使用fp为唯一身份标识，os_type业务方有可能传0,'0','1',1
  if (os_type != '0' && os_type != '1') {
    qs_total.fp = getFp();
  }
  if (verify_data) {
    qs_total.type = verify_data.type;
    qs_total.detail = verify_data.detail;
    qs_total.server_sdk_env = verify_data.server_sdk_env;
  }
  qs_total.subtype = type;
  qs_total.challenge_code = challenge_code;
  qs_total.os_name = os_name;
  if (!isNative) {
    if (props.h5_check_version) {
      qs_total.h5_check_version = props.h5_check_version;
      qs_total.sdk_version = props.h5_check_version;
    }
  }
  return qs_total;
}

export function getFp() {
  // 如果业务方传了fp，以业务方fp为主
  if (window.captchaOptions && window.captchaOptions.fp) {
    return window.captchaOptions.fp;
  }
  return Cookies.get(WEBID_KEY) || '';
}

export function mergeUUID() {
  var chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split(
    ''
  );
  var length = chars.length;
  var timePrex = new Date().getTime().toString(36);
  var uuid = [];
  uuid[8] = uuid[13] = uuid[18] = uuid[23] = '_';
  uuid[14] = '4';
  for (var i = 0, r; i < 36; i++) {
    if (!uuid[i]) {
      r = 0 | (Math.random() * length);
      uuid[i] = chars[i == 19 ? (r & 0x3) | 0x8 : r];
    }
  }
  return 'verify' + '_' + timePrex + '_' + uuid.join('');
}
export function getRect(element: any) {
  var rect = element.getBoundingClientRect();
  var top = document.documentElement.clientTop;
  var left = document.documentElement.clientLeft;
  return {
    top: rect.top - top,
    bottom: rect.bottom - top,
    left: rect.left - left,
    right: rect.right - left,
  };
}
export const optionsSort = (arr: Array<IObj>) => {
  return arr.sort((prev: IObj, curr: IObj) => {
    if (Object.keys(prev)[0] > Object.keys(curr)[0]) {
      return 1;
    } else {
      return -1;
    }
  });
};

export const mergeUrl = (baseUrl: string = '', suffixUrl: string = '') => {
  let url;
  if (baseUrl && suffixUrl) {
    if (baseUrl.slice(-1) === '/' && suffixUrl[0] === '/') {
      url = baseUrl + suffixUrl.slice(1);
    } else if (baseUrl.slice(-1) !== '/' && suffixUrl[0] !== '/') {
      url = `${baseUrl}/${suffixUrl}`;
    } else {
      url = `${baseUrl}${suffixUrl}`;
    }
  } else {
    if (suffixUrl) {
      url = suffixUrl;
    } else {
      url = baseUrl;
    }
  }
  if (!/^(http|https):/.test(url)) {
    url = `${window.location.protocol}${url}`;
  }
  return url;
};

interface ErrorStack<T> {
  data: T[]; // 在用户点击反馈前收集所有当前用户的错误消息
  finalStage: string; // 记录用户点击反馈的最后一个步骤
  push: (arg: T) => void;
  empty: () => void;
}
export const errorStack: ErrorStack<{
  action: string;
  msg?: string;
  time: number;
}> = {
  data: [],
  finalStage: '',
  push(err) {
    this.data.push(err);
  },
  empty() {
    this.data = [];
    this.finalStage = '';
  },
};

// 处理页面滑动穿透问题
type PageSlideHandler = {
  option: boolean | AddEventListenerOptions;
  init: (useCaptureStyle?: boolean) => void;
  disabled: () => void;
  allow: () => void;
};
let passiveSupported = false;
try {
  let options = Object.defineProperty({}, 'passive', {
    get: function () {
      passiveSupported = true;
    },
  });
  window.addEventListener('test', () => {}, options);
} catch (err) {}

function moveHandler(e: Event) {
  e.preventDefault();
}
export const pageSlideHandler: PageSlideHandler = {
  option: false,
  // useCaptureStyle 某些业务场景场景不支持options，支持业务方设置props.useCaptureStyle为true设置eventListener第三个参数固定为false
  init(useCaptureStyle = false) {
    this.option =
      !passiveSupported || useCaptureStyle ? false : { passive: false };
  },
  disabled() {
    if (!isNative) {
      document.addEventListener('touchmove', moveHandler, this.option);
    }
  },
  allow() {
    document.removeEventListener('touchmove', moveHandler, this.option);
  },
};

/**
 * 检测出 pad 环境，并将其标识为 mobile ，以便在 pad 上能使用移动端触摸版的 ai 对抗模型
 */
export const isMobileOrPad = () => {
  let JudgmentOfUa = /android|mobi|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(
    navigator.userAgent
  );
  if (JudgmentOfUa) {
    return JudgmentOfUa;
  } else {
    // 在 ipad 上打开火狐浏览器默认是桌面模式，这种状态下 UA 会和 mac 上的 Safari 的一样，所以需要通过 GPU 是否是 Apple 的来判断
    try {
      const webgl = document.createElement('canvas').getContext('webgl');
      const info = webgl && webgl.getExtension('WEBGL_debug_renderer_info');
      const renderer =
        webgl && info && webgl.getParameter(info.UNMASKED_RENDERER_WEBGL); // GPU 型号，e.g., "Intel(R) Iris(TM) Plus Graphics 640"
      return /Apple/i.test(renderer) && !!('ontouchstart' in window);
    } catch (error) {
      return false;
    }
  }
};

export const isURLOrBase64 = (url: string) => {
  return /^https?:\/\/|^data:.*,/.test(url);
};
export const isSafari = () => {
  return (
    /Safari/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent)
  );
};

export const isAndroid = (options: any) => {
  return options.os_type === '0';
};

export const isIOS = (options: any) => {
  return options.os_type === '1';
};

export const hasSettingsJSB = (options: any) => {
  // 判断安卓端上是否有getSettings的JSB，为了兼容旧版本
  return options.sdk_version >= '1.3.3';
};

export const isIPhone5 = () => {
  const { width, height } = window.screen;
  return width <= 320 && height <= 568;
};

export const isHorz = (orientation: number) => {
  return orientation == 1;
};

export const isHorzScale = (orientation: number) => {
  return isIPhone5() && isHorz(orientation);
};

export const getStylePropertyValue = (ele: Element, property: string) => {
  return window.getComputedStyle(ele).getPropertyValue(property);
};

export const getElementRect = (ele: Element) => {
  if (ele) {
    // em 布局可能有像素小数点，通过 window.getComputeStyle 可以获取到小数点
    const w = parseFloat(getStylePropertyValue(ele, 'width'));
    const h = parseFloat(getStylePropertyValue(ele, 'height'));
    return {
      w,
      h,
    };
  } else {
    return {
      w: 0,
      h: 0,
    };
  }
};

export const getVerifyImgWidth = (ele: Element) => {
  if (ele) {
    const image = ele.querySelector('#captcha-verify-image');
    if (image && image.getBoundingClientRect) {
      const rect = image.getBoundingClientRect();
      return rect.width;
    }
  }
  return -1;
};

export const getOrientation = () => {
  return Number(window.captchaOptions.orientation) || 2;
};

export const isRTL = (lang: string) => {
  return lang === 'ar';
};

export const disableSetBodyScroll = () => {
  const head = document.head || document.getElementsByTagName('head')[0];
  const style = document.createElement('style');
  style.textContent = `
    body.disable-scroll {
      overflow: hidden !important;
      height: 100vh !important;
    }
  `;
  head.appendChild(style);
  document.body.classList.add('disable-scroll');
  return () => {
    head.removeChild(style);
    document.body.classList.remove('disable-scroll');
  };
};

export const sleep = (ms: number = 0) => {
  return new Promise((resolve) => {
    setTimeout(resolve, ms);
  });
};

export const isObject = (obj: any) => {
  return Object.prototype.toString.call(obj) === '[object Object]';
};


export const getButton = (buttonEnum: number) => {
  let buttonText = '';
  switch (buttonEnum) {
    case 0:
      buttonText = 'left';break;
    case 1:
      buttonText = 'middle';break;
    case 2:
      buttonText = 'right';break;
    default:
      buttonText = 'unknown';break;
  }
  return  buttonText;
}
